var exports = {
  "Q": "x804f0401--31c8ac--content",
};

module.exports = exports;
